import React, { Component } from "react";

class TopBar extends Component {
  render() {
    return (
      <div id="top-bar">
        <div id="top-bar-inner" className="container">
          <div className="top-bar-inner-wrap">
            <div className="top-bar-content">
              <div className="inner">
                <span className="address content">Nairobi, Kenya</span>
                <span className="phone content">
                  0706494665 | 0717304599 | 0748221975
                </span>
                <span className="time content">
                  Mon-Sat: 7:00am - 6:30pm
                </span>
              </div>
            </div>

            <div className="top-bar-socials">
              <div className="inner">
                <span className="text">Follow us:</span>
                <span className="icons">

                  {/* Facebook */}
                  <a
                    href="https://www.facebook.com/john.kariuki.945342?mibextid=rS40aB7S9Ucbxw6v"
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label="Facebook"
                  >
                    <i className="fa fa-facebook" />
                  </a>

                  {/* Twitter */}
                  {/* <a
                    href="https://twitter.com/klizzhardware"
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label="Twitter"
                  >
                    <i className="fa fa-twitter" />
                  </a> */}

                  {/* Instagram */}
                  {/* <a
                    href="https://www.instagram.com/klizzclassichardware"
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label="Instagram"
                  >
                    <i className="fa fa-instagram" />
                  </a> */}

                  {/* WhatsApp */}
                  <a
                    href="https://wa.me/254706494665"
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label="WhatsApp"
                  >
                    <i className="fa fa-whatsapp" />
                  </a>

                </span>
              </div>
            </div>

          </div>
        </div>
      </div>
    );
  }
}

export default TopBar;
